import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { Campaign, CampaignCreate } from '@wdx/clmi/clmi-swagger-gen';
import { Observable } from 'rxjs';

@Injectable()
export class MarketingService {
    private http = inject(HttpClient);
    private config = inject(ConfigService);


    getCampaigns(): Observable<Campaign[]> {
        return this.http.get<Campaign[]>(
            `${this.config.getConfiguration().API_BASE}/campaign`,
        );
    }

    createCampaign(campaign: CampaignCreate): Observable<Campaign> {
        return this.http.post<CampaignCreate>(
            `${this.config.getConfiguration().API_BASE}/campaign`,
            campaign,
        );
    }

    getSingleCampaign(campaignId: string): Observable<Campaign> {
        return this.http.get<Campaign>(
            `${this.config.getConfiguration().API_BASE}/campaign/${campaignId}`,
        );
    }
}
